import { z } from 'zod';

import { POLLER_LAST_FAILURE_TYPES } from './constants';

// The API formats every timestamp below as `%Y-%m-%dT%H:%M:%SZ`, so there is no
// offset variant to accept here. Caveat: it appends that `Z` without converting
// to UTC, so on a deployment whose database session is not UTC these carry local
// wall-clock time mislabelled as UTC. Backend defect — don't compensate here, or
// it becomes invisible.
export const zodPollerErrorTrackingSchema = z.object({
  consecutiveErrors: z.number().nonnegative(),
  lastAlertDate: z.iso.datetime().nullable(),
  lastFailureReason: z.string().max(2000).nullable(),
  lastFailureType: z.enum(POLLER_LAST_FAILURE_TYPES).nullable(),
  lastPolledDln: z.iso.datetime().nullable(),
  lastRun: z.iso.datetime().nullable(),
  lastSuccessfulRun: z.iso.datetime().nullable(),
  numberPolledDlnsLastRun: z.number().nonnegative(),
  numberPolledDlnsTotal: z.number().nonnegative(),
  pollingProblem: z.boolean(),
  problemPresentSince: z.iso.datetime().nullable(),
  totalErrors: z.number().nonnegative(),
});
